'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Selectors


// Components


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _elementSelector = require('../../../../element/elementSelector');

var _selectedElementsSelector = require('../../../../element/selection/selectedElementsSelector');

var _elementCaptionUtil = require('../../../../components/caption/elementCaptionUtil');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _captionActions = require('../../../../components/caption/captionActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the selected IDs and the currently editing ID.
 * The first selected ID is the element we're interested in because we only apply the caption to one image element.
 * If the same image element is being edited then the caption will be visible.
 */
var getCaptionState = (0, _reselect.createSelector)(_elementSelector.getElements, _selectedElementsSelector.getSelectedElementIds, function (elements, selection) {
    var firstElementId = selection.first();
    var firstElement = elements.get(firstElementId);
    var showingCaption = firstElement ? (0, _elementCaptionUtil.getShowCaption)(firstElement) : false;

    return {
        selection: selection,
        showingCaption: showingCaption
    };
});

/**
 * Toggles the caption on and off whenever the caption tool is clicked by either changing the image element to be
 * currently editing (which by default will put the cursor into the field and show the caption), or deleting the
 * caption text and changing the image to not be editing so that the caption will no longer have focus.
 */
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        handleMouseDown: function handleMouseDown(event) {
            event.preventDefault();
            dispatch((0, _captionActions.toggleCaption)());
        }
    };
};

var CaptionTool = function CaptionTool(props) {
    var showingCaption = props.showingCaption,
        name = props.name;


    var iconName = showingCaption ? 'toolbar-caption-on' : 'toolbar-caption';

    return _react2.default.createElement(
        _Tool2.default,
        _extends({}, props, { name: name || 'Caption', isActive: showingCaption }),
        _react2.default.createElement(_Icon2.default, { name: iconName })
    );
};

CaptionTool.propTypes = {
    name: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    styleCommand: _propTypes2.default.string,
    styleType: _propTypes2.default.string,
    showingCaption: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(getCaptionState, mapDispatchToProps)(CaptionTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/captionTool/CaptionTool.js
// module id = 2228
// module chunks = 0